<template>
  <div class="member-evalutation-test" v-loading="loading">
    <EvaluationEmpty
      v-show="!loading && isEmpty"
      :show-btn="true"
    ></EvaluationEmpty>
    <div v-show="!loading && !isEmpty">
      <div class="total">
        <div ref="pie" class="pie"></div>
        <div class="pie-center">
          <p class="num" :class="totalNumClass">{{ count.total }}</p>
          <p class="label">做题次数</p>
        </div>
        <ul class="count-wrap">
          <li class="count-item">
            <i class="special"></i>
            <span class="label">{{ label.special }}</span>
            <span class="num">{{ count.special }}次</span>
          </li>
          <li class="count-item">
            <i class="paper"></i>
            <span class="label">{{ label.paper }}</span>
            <span class="num">{{ count.paper }}次</span>
          </li>
          <li class="count-item">
            <i class="random"></i>
            <span class="label">{{ label.random }}</span>
            <span class="num">{{ count.random }}次</span>
          </li>
          <li class="count-item">
            <i class="freedom"></i>
            <span class="label">{{ label.freedom }}</span>
            <span class="num">{{ count.freedom }}次</span>
          </li>
        </ul>
        <div class="correct-wrap">
          <el-progress
            type="circle"
            :percentage="+count.correct_rate"
            color="#43D57A"
            :stroke-width="12"
            :width="146"
            :show-text="false"
          ></el-progress>
          <div class="correct-center">
            <p class="num">
              <span>{{ count.correct_rate }}</span>
              <span class="tag">%</span>
            </p>
            <p class="label">正确率</p>
          </div>
        </div>
      </div>
      <div class="detail">
        <ul class="tabs-simple">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: item.type == searchCondition.type }"
            @click="onTab(item)"
          >
            {{ item.label }}
          </li>
        </ul>
        <el-form inline>
          <el-form-item>
            <el-date-picker
              v-model="datetimeRange"
              size="small"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              prefix-icon="none"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item v-show="searchCondition.type != 1">
            <el-input
              v-model="searchCondition.name"
              placeholder="请输入关键字"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="onSearch">
              搜索
            </el-button>
            <el-button size="small" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <Grid
          ref="grid"
          url="/api/app/practice/record"
          method="post"
          :search="searchCondition"
          :columns="tableColumns"
          :formatter="onFormatter"
          :showLoading="false"
        >
          <template slot="action" slot-scope="{ row }">
            <!-- buttons包一层div，不修改样式，解决出现省略号问题 -->
            <div>
              <el-button
                v-if="row.status == 1"
                type="primary"
                simple
                size="small"
                @click="onReport(row)"
              >
                查看报告
              </el-button>
              <el-button
                v-else-if="row.status == 2"
                type="primary"
                size="small"
                @click="onContinue(row)"
              >
                继续练习
              </el-button>
            </div>
          </template>
          <EmptyNew slot="empty">
            <div class="text" slot="title">
              <span>暂无数据，</span>
              <el-button
                type="text"
                @click="$router.push({ name: 'ExamIndex' })"
              >
                快去练习
              </el-button>
            </div>
          </EmptyNew>
        </Grid>
      </div>
    </div>
    <LimitModal ref="limitModal" />
  </div>
</template>

<script>
import echarts from "echarts";
import Grid from "@/components/Grid";
import EvaluationEmpty from "./EvaluationEmpty";
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "member-evalutation-test",
  components: {
    Grid,
    EvaluationEmpty,
    EmptyNew,
  },
  data() {
    return {
      questionType: "套卷练习",
      visible: false,
      isEmpty: true, // 如果4个tab页都没数据，则显示空页面
      loading: true,
      tabs: [
        { label: "专项练习", type: 3 },
        { label: "套卷练习", type: 2 },
        { label: "随机练习", type: 1 },
        { label: "自由组卷", type: 6 },
      ],
      myEchart: null,
      datetimeRange: null,
      label: {
        special: "专项练习",
        paper: "套卷练习",
        random: "随机练习",
        freedom: "自由组卷",
      },
      count: {
        special: 0,
        paper: 0,
        random: 0,
        freedom: 0,
        total: 0,
        correct_rate: 0,
      },
      tableColumns: [
        { label: "名称", prop: "title" },
        { label: "正确率", prop: "accuracy", width: 130 },
        { label: "开始练习时间", prop: "startTime", width: 200 },
        { label: "操作", slot: "action", align: "center", width: 110 },
      ],
      searchCondition: {
        type: 3,
        begin_time: "",
        end_time: "",
        name: "",
      },
    };
  },
  watch: {
    datetimeRange(val) {
      if (val) {
        this.searchCondition.begin_time = parseInt(+val[0] / 1000);
        this.searchCondition.end_time = parseInt(+val[1] / 1000);
      } else {
        this.searchCondition.begin_time = "";
        this.searchCondition.end_time = "";
      }
    },
  },
  computed: {
    totalNumClass() {
      const numStrLen = (this.count.total + "").length;
      if (numStrLen >= 6) {
        return "len6";
      } else if (numStrLen == 5) {
        return "len5";
      } else if (numStrLen == 4) {
        return "len4";
      }
      return null;
    },
  },
  async created() {
    await this.requestTotalInfo();
    await this.requestIsEmpty();
    triggerLoaded(this);
  },
  mounted() {
    this.initEchart();
  },
  methods: {
    // on event
    onTab(item) {
      this.searchCondition.type = item.type;
      this.onReset();
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.$pub.clearObj(this.searchCondition, ["type"]);
      this.datetimeRange = null;
      this.onSearch();
    },
    onFormatter(data) {
      data.forEach(i => {
        i.accuracy = i.accuracy || "--";
        i.startTime = new Date(i.start_time * 1000).formatLong();
      });
    },
    onReport(row) {
      if (this.searchCondition.type == 3) {
        this.$router.push({
          name: "ExamSpecialReport",
          query: {
            id: row.report_id,
            specialId: row.practise_id,
          },
        });
      } else if (this.searchCondition.type == 2) {
        if (row.is_can_do && row.is_can_do == 2) {
          //会员过期
          this.visible = true;
          this.questionType = "套卷练习";
          return;
        } else if (row.is_can_do && row.is_can_do == 3) {
          //判断有没有权限进入套卷练习
          this.$message.warning("您没有权限进入");
          return;
        }
        this.$router.push({
          name: "ExamPackageReport",
          query: {
            id: row.report_id,
            package_id: row.package_id,
            package_name: row.package_name,
            paper_id: row.exam_id,
            is_can_do: row.is_can_do, ///判断套卷权限
          },
        });
      } else if (this.searchCondition.type == 1) {
        this.$router.push({
          name: "ExamRandomReport",
          query: {
            id: row.report_id,
          },
        });
      } else if (this.searchCondition.type == 6) {
        this.$router.push({
          name: "ExamFreedomReport",
          query: {
            id: row.report_id,
          },
        });
      }
    },
    async onContinue(row) {
      if (this.searchCondition.type == 3) {
        //判断随机专项免费答题次数是否用完
        await this.$refs.limitModal.checkAnswer(3, "专项练习");
        this.$router.push({
          name: "ExamSpecialDo",
          query: {
            id: row.report_id,
            specialId: row.practise_id,
            specialName: row.title,
            examType: "专项练习",
          },
        });
      } else if (this.searchCondition.type == 2) {
        if (row.is_can_do && row.is_can_do == 2) {
          //会员过期
          this.visible = true;
          this.questionType = "套卷练习";
          return;
        } else if (row.is_can_do && row.is_can_do == 3) {
          //判断有没有权限进入套卷练习
          this.$message.warning("您没有权限进入");
          return;
        }
        this.$router.push({
          name: "ExamPackageDo",
          query: {
            id: row.report_id,
            package_id: row.package_id,
            package_name: row.package_name,
            paper_id: row.exam_id,
          },
        });
      } else if (this.searchCondition.type == 1) {
        //判断随机练习免费答题次数是否用完
        await this.$refs.limitModal.checkAnswer(1, "随机练习");
        this.$router.push({
          name: "ExamRandomDo",
          query: {
            id: row.report_id,
            examType: "随机练习",
          },
        });
      } else if (this.searchCondition.type == 6) {
        //判断自由组卷免费答题次数是否用完
        await this.$refs.limitModal.checkAnswer(6, "自由组卷");
        this.$router.push({
          name: "ExamFreedomDo",
          query: {
            id: row.report_id,
            examType: "自由组卷",
          },
        });
      }
    },
    // other
    getData() {
      this.requestTotalInfo();
      this.requestIsEmpty();
      this.onReset();
    },
    initEchart() {
      this.myEchart = echarts.init(this.$refs.pie);
      this.setEchart();
    },
    setEchart(option) {
      if (!this.myEchart) return;
      option = option || {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "占比",
            type: "pie",
            center: [129, "49%"],
            radius: [59, 76],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
              color: "#fff",
              fontSize: 16,
            },
            itemStyle: {
              normal: {
                borderWidth: 4,
                borderColor: "#fff",
              },
            },
            data: [
              {
                value: this.count.special,
                name: this.label.special,
                itemStyle: { color: "#f5c132" },
              },
              {
                value: this.count.paper,
                name: this.label.paper,
                itemStyle: { color: "#3ba2ff" },
              },
              {
                value: this.count.random,
                name: this.label.random,
                itemStyle: { color: "#38d3a7" },
              },
              {
                value: this.count.freedom,
                name: this.label.freedom,
                itemStyle: { color: "#ff4d4d" },
              },
            ],
          },
        ],
      };
      this.myEchart.setOption(option);
    },
    // request
    async requestTotalInfo() {
      let data = await this.$http.get(
        "/api/app/practice/practiceNum",
        {},
        { showLoading: false },
      );
      this.count.correct_rate = data.accuracy;
      this.count.special = data.spec_num;
      this.count.paper = data.exam_num;
      this.count.random = data.rand_num;
      this.count.freedom = data.freedom_num;
      this.count.total = data.total_num;
      this.setEchart();
      // echart间隔样式修正
      const zeroCount = [data.spec_num, data.exam_num, data.rand_num].filter(
        i => i == 0,
      ).length;
      if (zeroCount == 2) {
        this.setEchart({
          series: [
            {
              radius: [63, 76],
              itemStyle: {
                normal: {
                  borderWidth: 0,
                },
              },
            },
          ],
        });
      }
    },
    async requestIsEmpty() {
      this.loading = true;
      let datas = await Promise.all([
        this.$http.post(
          "/api/app/practice/record",
          { type: 1 },
          { showLoading: false },
        ),
        this.$http.post(
          "/api/app/practice/record",
          { type: 2 },
          { showLoading: false },
        ),
        this.$http.post(
          "/api/app/practice/record",
          { type: 3 },
          { showLoading: false },
        ),
        this.$http.post(
          "/api/app/practice/record",
          { type: 6 },
          { showLoading: false },
        ),
      ]);
      this.loading = false;
      for (const val of datas) {
        if (val.total) {
          this.isEmpty = false;
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.member-evalutation-test {
  min-height: 738px;
  .total {
    position: relative;
    border-bottom: 1px solid #ededed;
    margin-bottom: 27px;
    .pie {
      width: 360px;
      height: 200px;
    }
    .pie-center {
      position: absolute;
      top: 41px;
      left: 72px;
      width: 114px;
      height: 114px;
      border-radius: 50%;
      // background-color: #ccc;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .num {
        font-size: 44px;
        line-height: 1;
        font-weight: 500;
        color: #333;
        margin-bottom: 10px;
        text-align: center;
        word-break: break-word;
        &.len4 {
          font-size: 40px;
        }
        &.len5 {
          font-size: 36px;
        }
        &.len6 {
          font-size: 30px;
        }
      }
      .label {
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
        color: #666;
      }
    }
    .count-wrap {
      position: absolute;
      top: 50%;
      left: 250px;
      transform: translateY(-50%);
      .count-item {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
        &:last-of-type {
          margin-bottom: 0;
        }
        i {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #eee;
          margin-right: 9px;
          &.special {
            background-color: #f5c132;
          }
          &.paper {
            background-color: #3ba2ff;
          }
          &.random {
            background-color: #38d3a7;
          }
          &.freedom {
            background-color: #ff4d4d;
          }
        }
        .label {
          color: #666;
          margin-right: 46px;
        }
        .num {
          color: #333;
        }
      }
    }
    .correct-wrap {
      position: absolute;
      top: calc(50% + 5px);
      right: 123px;
      transform: translateY(-50%);
      .correct-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .num {
          font-size: 30px;
          line-height: 1;
          font-weight: 500;
          color: #333;
          margin-bottom: 8px;
          .tag {
            font-size: 16px;
            line-height: 1;
            margin-left: 3px;
          }
        }
        .label {
          font-size: 14px;
          line-height: 1;
          color: #666;
        }
      }
    }
  }
  .detail {
    .tabs-simple {
      margin-bottom: 15px;
    }
  }
  /deep/ .el-date-editor--datetimerange {
    width: 350px;
    position: relative;
    top: 1px;
  }
}
.empty {
  img {
    position: relative;
    left: -12px;
  }
}
</style>
